
const lockedFlags: string[] = [];

export const flagSet = (flag: string) => lockedFlags.includes(flag);

export const withFlag = (action: (...args: any[]) => any, flag: string): void => {
    if (lockedFlags.indexOf(flag) === -1) {
        lockedFlags.push(flag);
        try {
            action();
        } catch (err) {
            console.error(err);
        } finally {
            lockedFlags.splice(lockedFlags.indexOf(flag), 1);
        }
    }
};

export const withFlagAsync = async (action: (...args: any[]) => Promise<any>, flag: string): Promise<void> => {
    if (lockedFlags.indexOf(flag) === -1) {
        lockedFlags.push(flag);
        try {
            await action();
        } catch (err) {
            console.error(err);
        } finally {
            lockedFlags.splice(lockedFlags.indexOf(flag), 1);
        }
    }
};
